module.exports = __webpack_public_path__ + "static/media/dia-do-professor.9626b046.png";